import { AdminBillableServiceGridSortColumn } from "@/Administration/Models/UI/BillableService/AdminBillableServiceGridSortColumn";
import { BillableServiceUIModel } from "@/Administration/Models/UI/BillableService/BillableServiceUIModel";
import { CostCenterUIModel } from "@/Administration/Models/UI/CostCenterUIModel";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { BillableServiceItem } from "@/Common/Models/BillableServiceItem";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class AdministrationBillableServiceHandler extends BaseOperationHandler {
    private readonly helper: MyleHelper;

    constructor() {
        super();
        this.helper = new MyleHelper();
        this.RegisterOperation(LocalOperations.AdministrationBillableService.RefreshGrid, this.refreshBillableServices);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.SearchSettings_SearchTextChanged, this.searchSettingsNameFilterChanged);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.SearchSettings_Open, this.openSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.SearchSettings_Close, this.closeSearchSettings);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableService_OnSettingsContainerCheckboxChange, this.onSearchSettingsCheckedChanged);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableService_SearchSettings_OkClick, this.searchSettingsOkClick);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableServiceEdit_Open, this.openBillableServiceEdit);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableServiceEdit_Close, this.closeBillableServiceEdit);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableServiceEdit_Save, this.upsertBillableService);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.OpenCreateNewBillableService, this.openCreateNewBillableServicePopup);

        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableService_CurrentPageChange, this.onPageChange);
        this.RegisterOperation(LocalOperations.AdministrationBillableService.BillableService_SearchSettings_OnResultsPerPageChange, this.resulstPerPageChange);

        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.columnSort);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.onContainerClick);

        this.RegisterOperation(LocalOperations.AdministrationBillableService.SearchSettings_ColumnOrderingPopup_Open, this.columnOrderingPopup_Open);
    }

    private refreshBillableServices(request: LocalEvent, store: AdministrationStore): void {
        let isReload = request.Get<boolean>("reload");

        if (isReload) {
            store.billableServiceTabModel = store.billableServiceTabModel.set("SelectedPageNumber", 1);

            if (administrationStore.timeoutReferenceRefreshBillableServices !== -1) {
                clearTimeout(administrationStore.timeoutReferenceRefreshBillableServices);
                administrationStore.timeoutReferenceRefreshBillableServices = -1;
            }

            administrationStore.timeoutReferenceRefreshBillableServices = window.setTimeout(
                () => store.billableServiceAction.LoadFilteredBillableService(store.billableServiceTabModel),
                250
            );
        }
        else {
            store.billableServiceAction.LoadFilteredBillableService(store.billableServiceTabModel);
        }
    }

    private columnSort(request: LocalEvent, store: AdministrationStore): void {
        let tableTarget = request.Get<MyleTableTarget>("target");
        if (tableTarget === MyleTableTarget.Myle_AdminBillableServices_ColumnSortClick) {
            let currentSortCol = store.billableServiceTabModel.get("GridSortColumn");
            let sortDir = store.billableServiceTabModel.get("GridSortDirection");
            let sortCol = request.Get<AdminBillableServiceGridSortColumn>("sortColumn");

            if (currentSortCol != sortCol) {
                sortDir = SortDirection.ASC;
            }
            else {
                if (sortDir == SortDirection.ASC)
                    sortDir = SortDirection.DESC;
                else
                    sortDir = SortDirection.ASC;
            }

            store.billableServiceTabModel = store.billableServiceTabModel.set("GridSortColumn", sortCol);
            store.billableServiceTabModel = store.billableServiceTabModel.set("GridSortDirection", sortDir);

            request.AddItem("reload", false);
            this.refreshBillableServices(request, store);
        }
    }

    private searchSettingsNameFilterChanged(request: LocalEvent, store: AdministrationStore): void {
        let text = request.Get<string>("filterText");
        store.billableServiceTabModel = store.billableServiceTabModel.set("BillableServiceSearchText", text);
        request.AddItem("reload", false);

        window.setTimeout(() => {
            this.refreshBillableServices(request, store);
        }, 250);
    }

    private onContainerClick(request: LocalEvent, store: AdministrationStore): void {
        if (store.billableServiceTabModel.get("SearchMenuOpen") == true && store.billableServiceTabModel.get("DisplayEditBillableServiceComponent") == false)
            this.searchSettingsOkClick(request, store);
    }

    private openSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        store.billableServiceTabModel = store.billableServiceTabModel.set("SearchMenuOpen", true);
    }

    private closeSearchSettings(request: LocalEvent, store: AdministrationStore): void {
        store.billableServiceTabModel = store.billableServiceTabModel.set("SearchMenuOpen", false);
    }

    private onSearchSettingsCheckedChanged(request: LocalEvent, store: AdministrationStore): void {
        var target = request.Get<CheckboxTarget>("target");
        var checked = request.Get<boolean>("checked");
        var id = request.Get<string>("id");

        switch (target) {
            case CheckboxTarget.Myle_Admin_BillableService_Sites_AllCheck:
                {
                    store.billableServiceTabModel = store.billableServiceTabModel.set("Sites_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("Sites", this.helper.ChangeCheckStateFromAllICheckable(store.billableServiceTabModel.get("Sites"), checked));
                    store.billableServiceTabModel = store.billableServiceTabModel.set("ShowNullSites", checked);
                    let centers = store.GetCostCentersSelectedSites(CheckboxTarget.Myle_Admin_BillableService_CostCenters_Check);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters", centers);
                }
                break;

            case CheckboxTarget.Myle_Admin_BillableService_Sites_Check:
                {
                    let newSites = this.helper.FindUpdateICheckableItem<SiteUIModel>(store.billableServiceTabModel.get("Sites"), id, checked);
                    if (!checked)
                        store.billableServiceTabModel = store.billableServiceTabModel.set("Sites_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("Sites", newSites);
                    let centers = store.GetCostCentersSelectedSites(CheckboxTarget.Myle_Admin_BillableService_CostCenters_Check);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters", centers);
                }
                break;

            case CheckboxTarget.Myle_Admin_BillableService_CostCenters_AllCheck:
                {
                    store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters", this.helper.ChangeCheckStateFromAllICheckable(store.billableServiceTabModel.get("CostCenters"), checked));
                    store.billableServiceTabModel = store.billableServiceTabModel.set("ShowNullCostCenters", checked);
                }
                break;
            case CheckboxTarget.Myle_Admin_BillableService_CostCenters_Check:
                {
                    let newCenters = this.helper.FindUpdateICheckableItem<CostCenterUIModel>(store.billableServiceTabModel.get("CostCenters"), id, checked);
                    if (!checked)
                        store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters", newCenters);
                }
                break;
            case CheckboxTarget.Myle_Admin_BillableService_Sites_NullCheck:
                {
                    if (!checked)
                        store.billableServiceTabModel = store.billableServiceTabModel.set("Sites_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("ShowNullSites", checked);
                }
                break;
            case CheckboxTarget.Myle_Admin_BillableService_CostCenters_NullCheck:
                {
                    if (!checked)
                        store.billableServiceTabModel = store.billableServiceTabModel.set("CostCenters_AllSelected", checked);
                    store.billableServiceTabModel = store.billableServiceTabModel.set("ShowNullCostCenters", checked);
                }
                break;

            default:
                break;
        }
    }

    private searchSettingsOkClick(request: LocalEvent, store: AdministrationStore): void {
        store.billableServiceTabModel = store.billableServiceTabModel.set("SearchMenuOpen", false);
        store.billableServiceTabModel = store.billableServiceTabModel.set("SelectedPageNumber", 1);

        store.billableServiceAction.LoadFilteredBillableService(store.billableServiceTabModel);
    }

    private openBillableServiceEdit(request: LocalEvent, store: AdministrationStore): void {
        let rowObject: any = request.Get("rowData");
        let editedBillableService: BillableServiceUIModel = BillableServiceUIModel.fromCompositeObject(rowObject);
        let isOpen = store.billableServiceTabModel.get("DisplayEditBillableServiceComponent");
        store.billableServiceTabModel = store.billableServiceTabModel.set("DisplayEditBillableServiceComponent", !isOpen);

        store.billableServiceTabModel = store.billableServiceTabModel.set("EditedBillableService", editedBillableService.clone());
    }

    private closeBillableServiceEdit(request: LocalEvent, store: AdministrationStore): void {
        let editedBillableService: BillableServiceUIModel = BillableServiceUIModel.fromCompositeObject(null);
        store.billableServiceTabModel = store.billableServiceTabModel.set("EditedBillableService", editedBillableService);
        store.billableServiceTabModel = store.billableServiceTabModel.set("DisplayEditBillableServiceComponent", false);
    }

    private upsertBillableService(request: LocalEvent, store: AdministrationStore): void {
        let service = request.Get<BillableServiceItem>("Service");

        if (service.LastUpdatedBy || service.LastUpdatedBy == null)
            service.LastUpdatedBy = sessionStore.userId;
        if (service.CreatedBy || service.CreatedBy == null)
            service.CreatedBy = sessionStore.userId;

        store.billableServiceAction.upsertBillableSErvice(service);
    }

    private openCreateNewBillableServicePopup(request: LocalEvent, store: AdministrationStore): void {
        let isOpen = store.billableServiceTabModel.get("DisplayEditBillableServiceComponent");
        store.billableServiceTabModel = store.billableServiceTabModel.set("DisplayEditBillableServiceComponent", !isOpen);

        let editedBillableService = new BillableServiceUIModel();
        store.billableServiceTabModel = store.billableServiceTabModel.set("EditedBillableService", editedBillableService);
    }

    private onPageChange(request: LocalEvent, store: AdministrationStore): void {
        var value = request.Get<number>("Page");
        store.billableServiceTabModel = store.billableServiceTabModel.set("SelectedPageNumber", value);
        this.refreshBillableServices(request, store);
    }

    private resulstPerPageChange(request: LocalEvent, store: AdministrationStore): void {
        store.billableServiceTabModel = store.billableServiceTabModel.set("SelectedPageNumber", 1);
        store.billableServiceTabModel = store.billableServiceTabModel.set("SelectedPageSizeOption", request.Get<number>("value"));
        this.refreshBillableServices(request, store);
    }

    private columnOrderingPopup_Open(request: LocalEvent, store: AdministrationStore): void {
        let isOpen = store.billableServiceTabModel.get("ColumnOrderingPopupOpen");
        store.billableServiceTabModel = store.billableServiceTabModel.set("ColumnOrderingPopupOpen", !isOpen);
    }
}

export { AdministrationBillableServiceHandler };
